import { get } from './index';

export const search = (year, month) => {
    return get("api/order/" + year + "/" + month);
}

export const getById = (id) => {
    return get("api/order/" + id);
}